export class Constants {
    static maxUnknowns = 5;
    static maxNoc = 6;

}